import "./Pagination.css";
import React from "react";
import Pagination from "react-bootstrap/Pagination";

function template() {
  return (
    <div className="pagination mx-auto">
      <Pagination>
        <Pagination.Prev />
        
        <Pagination.Item active>{2}</Pagination.Item>
        
        <Pagination.Next />
      </Pagination>
    </div>
  );
}

export default template;
